import {ISpecialFeature as IGVLSpecialFeatureInfo, VendorList} from "./vendor-list";
import {Vendor} from "./vendor";
import cmp from "../context/context";

class SpecialFeature {

    public static build(featureId:number) : SpecialFeature|null {
        const gvlFeature: IGVLSpecialFeatureInfo|undefined = cmp().vendorList?.getSpecialFeatureInfo(featureId);
        if (gvlFeature) {
            return new SpecialFeature(gvlFeature);
        }
        return null;
    }

    private constructor(private readonly _gvlSpecialFeatureInfo: IGVLSpecialFeatureInfo) {

    }

    public get id() : number {
        return this._gvlSpecialFeatureInfo.id;
    }

    public get name() : string {
        return this._gvlSpecialFeatureInfo.name;
    }

    public get description() : string {
        return this._gvlSpecialFeatureInfo.description;
    }

    public get illustrations() : string[] {
        return this._gvlSpecialFeatureInfo.illustrations??[];
    }

    public get vendors() : Vendor[] {
        const vendorList: VendorList|undefined = cmp().vendorList;

        if (!vendorList)  return [];

        const vendorsIds:number[] = vendorList.vendorIds().filter(vendorId => vendorList.getVendorInfo(vendorId)?.specialFeatures.includes(this._gvlSpecialFeatureInfo.id));

        const vendors:Vendor[] = [];
        vendorsIds.forEach((vendorId:number) => {
            const vendor: Vendor|null = Vendor.build(vendorId);
            if (vendor) {
                vendors.push(vendor);
            }
        });
        return vendors.sort((vendorA:Vendor, vendorB:Vendor) => {
            return vendorA.name.localeCompare(vendorB.name);
        });
    }

    public get accepted() : boolean|undefined {
        return cmp().tcString?.specialFeatures[this.id];
    }

}

export {SpecialFeature}
